module.exports = __webpack_public_path__ + "static/media/284229656.8ae2c1ff.png";